import React from 'react';
import { useActor } from '@xstate/react';
import { FormStateBasic } from 'informed';

import {
  OTP_LOADING,
  OtpFieldRefType,
  VERIFY_OTP_BUTTON_CLICKED
} from '@nw/auth-core';
import { isValidSixDigitOTP } from '@nw/shared/utils';

//TODO: Use form constants from shared
import {
  PublicFormMachineSendType,
  PublicFormMachineStateType
} from '../../../form/machines/PublicFormsMachine/types';
//TODO: Use product constants from shared
import { productFormsMachineEvents } from '../../../product/constants/formMachineConstants';
import {
  AssignConfigEventToContext,
  CallEventsFromConfig,
  PublicProductFormMachineSendType,
  PublicProductFormMachineStateType
} from '../../../product/machines/PublicFormsMachine/types';

import { CustomClassNamesInterface } from '../../types/MiscellaneousTypes';

import {
  ButtonComponent,
  buttonSize,
  buttonVariant,
  ButtonSize,
  ButtonVariant
} from '../ButtonComponent';

import {
  SubmitButtonFrame,
  SubmitButtonText,
  SubmitButtonTextWrapper
} from '../MultiStepSubmitButtonContent/styledComponents';

interface MultiStepVerifyOTPProps {
  otp: string;
  otpFieldRef: OtpFieldRefType;
  nextStepButtonId: string | undefined;
  nextStepButtonText: string | undefined;
  publicFormMachineSend:
  | PublicProductFormMachineSendType
  | PublicFormMachineSendType;
  publicFormMachineState:
  | PublicProductFormMachineStateType
  | PublicFormMachineStateType;
  nextBtnActions: string[] | undefined;
  formValues: FormStateBasic['values'];
  customClassNames: CustomClassNamesInterface;
  designSystemType?: string;
}

const MultiStepVerifyOTP: React.FC<MultiStepVerifyOTPProps> = ({
  otp,
  otpFieldRef,
  nextStepButtonId,
  nextStepButtonText,
  publicFormMachineSend,
  publicFormMachineState,
  nextBtnActions = [],
  formValues,
  customClassNames,
  designSystemType
}) => {
  const [otpFieldState, otpFieldSend] = useActor(otpFieldRef);
  const { shouldShowGetOTP, isOTPButtonLoading, isNextAndSubmitBtnLoading } =
    publicFormMachineState.context;

  //TODO:Check and resolve error while giving type to otpFieldSend
  const verifyOTPOnSubmit = (otpFieldSend: any): void => {
    if (publicFormMachineState.context.isOtpVerified) {
      const alreadyPresentConfigAction =
        publicFormMachineState.context.eventsFromConfig;
      publicFormMachineSend({
        type: productFormsMachineEvents.assignConfigEventsToContext,
        configEvent:
          alreadyPresentConfigAction.length > 0
            ? alreadyPresentConfigAction
            : nextBtnActions,
        values: formValues
      } as AssignConfigEventToContext);
      publicFormMachineSend({
        type: productFormsMachineEvents.callEventsFromConfig
      } as CallEventsFromConfig);
    } else {
      publicFormMachineSend({
        type: productFormsMachineEvents.assignConfigEventsToContext,
        configEvent: nextBtnActions
      } as AssignConfigEventToContext);
      otpFieldSend({
        type: VERIFY_OTP_BUTTON_CLICKED,
        values: { otp }
      });
    }
  };

  const getIsOTPButtonLoading = () => {
    if (shouldShowGetOTP) {
      return isOTPButtonLoading;
    } else return isNextAndSubmitBtnLoading;
  };

  return (
    <ButtonComponent
      id={nextStepButtonId}
      isDisabled={!isValidSixDigitOTP(otp)}
      isLoading={otpFieldState.tags.has(OTP_LOADING) || getIsOTPButtonLoading()}
      type={'button'}
      variant={buttonVariant.primary as ButtonVariant}
      size={buttonSize.large as ButtonSize}
      onClick={() => verifyOTPOnSubmit(otpFieldSend)}
      className={customClassNames.nextAndSubmitButton}
      shouldShrinkButtonWhileLoading={false}
      designSystemType={designSystemType}
      data-testid={'multi-step-verify-otp-button'}
    >
      <SubmitButtonTextWrapper className="otp-verification-text-wrapper">
        <SubmitButtonFrame className="otp-verification-frame"></SubmitButtonFrame>
        <SubmitButtonText className="otp-verification-text">
          {nextStepButtonText}
        </SubmitButtonText>
      </SubmitButtonTextWrapper>
    </ButtonComponent>
  );
};

export default MultiStepVerifyOTP;
